/**
 * ЭТАП 1 · Шаг 3 — SSR+client shim для react-lazy-load-image-component.
 *
 * Либа — webpack-UMD (build/index.js): именованные экспорты навешиваются
 * динамически (r.d(...)), статические лексеры их не видят → именованный импорт
 * падает под dev-SSR во всех режимах. Плюс интероп РАЗНЫЙ на сервере и клиенте:
 *  - сервер (Node): default-импорт даёт объект exports;
 *  - клиент (Vite-бандл UMD): default === undefined → "Cannot read properties
 *    of undefined (reading 'LazyLoadImage')".
 *
 * Поэтому берём namespace и устойчиво выбираем уровень обёртки, где реально
 * лежит LazyLoadImage (работает и на сервере, и на клиенте). Проверено спайком.
 * alias `^react-lazy-load-image-component$` → этот файл (см. vite.start.config.mts).
 */
// @ts-ignore -- у пакета нет типов на подпуть build/index.js
import * as ns from 'react-lazy-load-image-component/build/index.js';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const candidates: any[] = [ns, (ns as any)?.default, (ns as any)?.default?.default];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mod: any = candidates.find((c) => c && c.LazyLoadImage) ?? {};

export const LazyLoadImage = mod.LazyLoadImage;
export const LazyLoadComponent = mod.LazyLoadComponent;
export const trackWindowScroll = mod.trackWindowScroll;
export default mod;
